import React from "react";
import { useState, useEffect } from "react";
import Category_icon from "../Images/Group 22562.png";

import "../Blog.css";
import "./ReadMore.css";
import { Link, useNavigate, useParams } from "react-router-dom";




import { useContext } from "react";
import { Context } from "../../../utils/context";
import { BlogCategoryData, SingleBlogData } from "../../../utils/apis/blogs/blogsapi";
import { Breadcrumb } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
const ReadMore = () => {

  const { id } = useParams();

  const navigate = useNavigate();
  const { getData, mainPage, setMainPage, zoneid, setZoneid, date, setDate, IMG_URL } = useContext(Context)

  const [blogDetail, setBlogDetail] = useState();
  const [blogCategory, setBlogCategory] = useState();
  const [category, setCategory] = useState();


  const getBlogDetail = async () => {
    const res = await SingleBlogData(id)
    if (res?.success) {
      console.log(res.data, 'BlogDetail');
      setBlogDetail(res?.data);
    }
  };

  const getBlogs = async () => {
    const res = await BlogCategoryData()
    if (res?.success) {
      console.log(res.data, 'BlogsCategory');
      setBlogCategory(res?.data);
      setCategory(res?.data?.[0]?.id);
    }
  };

  const passCategory = async (id) => {
    navigate(`/blog/${id}`);
  };

  useEffect(() => {

    getBlogDetail();
    getBlogs();
  }, []);
  return (
    <>
      <section className="Blog mb-5 desktop-view-blog">
        <div className="container">


          <div className="Breadcrumb_comp">
            <Breadcrumb>
              <Breadcrumb.Item className="firstbread" href="/">
                Home <FontAwesomeIcon icon={faChevronRight} />{" "}
              </Breadcrumb.Item>
              <Breadcrumb.Item href="/blog" >
                Blogs <FontAwesomeIcon icon={faChevronRight} />{" "}
              </Breadcrumb.Item>
              <Breadcrumb.Item href="#" active>
                {blogDetail?.blog_name}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <div className="row me-0 ms-0">
            <div className="col-xl-3 col-lg-4 col-md-6  p-0">
              <div className="card-sidebar pb-5">
                <div className="categary-class pt-3">
                  <img src={Category_icon} alt="Category_icon" className="Category_icon" /><span className="categories-txt"> Categories</span>
                  <div className="icon-txt my-2"></div>
                </div>
                {/* <div className="dashed-line"></div> */}

                <div
                  className="nav flex-column nav-pills me-3 mt-3 card-body sidebar-section"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  {blogCategory?.map((val, index) => (
                    <button
                      className={blogDetail?.blog_category_id == val?.id ? "nav-link active" : "nav-link"}
                      id="v-pills-home-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-home"
                      type="button"
                      role="tab"
                      aria-controls="v-pills-home"
                      aria-selected="true"
                      onClick={() => passCategory(val?.id)}
                    >
                      {val?.name}
                    </button>
                  ))}
                  {/* <button
                    className="nav-link"
                    id="v-pills-Tarat-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-Tarat"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-profile"
                    aria-selected="false"
                  >
                    Tarat
                  </button> */}

                </div>
              </div>

            </div>
            <div className="col-xl-8 col-lg-8 col-md-12 mx-auto">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                  tabindex="0">
                  <div className="row">
                    <div className="col-xl-4 col-lg-5 col-md-6">
                      <div className="Tarot_img_sec">
                        <img
                          src={IMG_URL + blogDetail?.image}
                          alt="Tarot_img"
                          className="tarot_img"
                        />

                      </div>
                    </div>
                    <div className="col-xl-7 col-lg-7 col-md-6">
                      <div className="tarot-heading">{blogDetail?.blog_name}</div>
                      <div className="main mt-2">
                        <div class="line me-2"></div>
                        <div class="square"></div>
                        <div class="line ms-2"></div>
                      </div>
                      <p className="tarot-info" dangerouslySetInnerHTML={{ __html: blogDetail?.description }}>
                      </p>
                    </div>
                  </div>


                  <div className="row mt-5">
                    <div className="col-lg-12 col-md-12">
                      <p className="tarot-info" dangerouslySetInnerHTML={{ __html: blogDetail?.conclusion }}>
                      </p>
                    </div>
                  </div>


                  <div className="row mt-5">
                    <div className="col-lg-12 col-md-12">
                      <div className="conclusion">Conclusion</div>

                      <p className="tarot-info" dangerouslySetInnerHTML={{ __html: blogDetail?.conclusion }}>
                      </p>
                    </div>
                  </div>
                </div>




                <div
                  className="tab-pane fade"
                  id="v-pills-Tarat"
                  role="tabpanel"
                  aria-labelledby="v-pills-Tarat-tab"
                  tabindex="0"
                >
                  <div className="row">
                    <div className="col-xl-4 col-lg-6 col-md-6"></div>
                    <div className="col-xl-4 col-lg-6 col-md-6"></div>
                    <div className="col-xl-4 col-lg-6 col-md-6"></div>
                    <div className="col-xl-4 col-lg-6 col-md-6 mt-3"></div>
                    <div className="col-xl-4 col-lg-6 col-md-6 mt-3"></div>
                    <div className="col-xl-4 col-lg-6 col-md-6  mt-3"></div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-vastu"
                  role="tabpanel"
                  aria-labelledby="v-pills-disabled-tab"
                  tabindex="0"
                >
                  <div className="row">
                    <div className="col-xl-4 col-lg-6 col-md-6"></div>
                    <div className="col-xl-4 col-lg-6 col-md-6"></div>
                    <div className="col-xl-4 col-lg-6 col-md-6"></div>
                    <div className="col-xl-4 col-lg-6 col-md-6"></div>
                    <div className="col-xl-4 col-lg-6 col-md-6"></div>
                    <div className="col-xl-4 col-lg-6 col-md-6 "></div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-messages"
                  role="tabpanel"
                  aria-labelledby="v-pills-messages-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabindex="0"
                >
                  ...
                </div>
              </div>
            </div>
          </div>

          {/* <div className="row">
            <div className="icons">
              <div className="social-image ">
                <img src={whatappimg} className="social-icon mb-3" />
              </div>
              <div className="social-image ">
                <img src={linkdinimg} className="social-icon mb-3" />
              </div>
              <div className="social-image ">
                <img src={twitterimg} className="social-icon mb-3" />
              </div>
              <div className="social-image ">
                <img src={facebookimg} className="social-icon mb-3" />
              </div>
            </div>
          </div> */}

        </div>
      </section>

      <section className="Blog mb-5 mobile-view-blog">
        <div className="container">


          <div className="Breadcrumb_comp">
            <Breadcrumb>
              <Breadcrumb.Item className="firstbread" href="/">
                Home <FontAwesomeIcon icon={faChevronRight} />{" "}
              </Breadcrumb.Item>
              <Breadcrumb.Item href="/blog" >
                Blogs <FontAwesomeIcon icon={faChevronRight} />{" "}
              </Breadcrumb.Item>
              <Breadcrumb.Item href="#" active>
                {blogDetail?.blog_name}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <div className="row">
            <div className="col-12">


              <div className="Tarot_img_sec text-center">
                <img
                  src={IMG_URL + blogDetail?.image}
                  alt="Tarot_img"
                  className="tarot_img"
                />
              </div>
              <div className="col-12">
                <div className="tarot-heading mt-3">{blogDetail?.blog_name}</div>
                <div className="main-heading mx-auto mt-2 mb-4">
                  <div class="line me-1"></div>
                  <div class="square"></div>
                  <div class="line ms-1"></div>
                </div>
                <p className="tarot-info" dangerouslySetInnerHTML={{ __html: blogDetail?.description }}>
                </p>

                <div className="row mt-5">
                  <div className="col-lg-12 col-md-12">
                    <p className="tarot-info" dangerouslySetInnerHTML={{ __html: blogDetail?.conclusion }}>
                    </p>
                  </div>
                </div>

                <div className="conclusion">Conclusion</div>
                <p className="tarot-info" dangerouslySetInnerHTML={{ __html: blogDetail?.conclusion }}>
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ReadMore;
